import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "!mapbox-gl";
/* eslint import/no-webpack-loader-syntax: off */
import React, { useState, useRef, useEffect } from "react";
// import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker'; // Load worker code separately with worker-loader

// mapboxgl.workerClass = MapboxWorker;
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESSTOKEN;
// shape of the props
// {
//  positionInfos: [{address: "some address"}]
// }

const MapBox = ({ bookingObj, mapRoute }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(77.5848);
  const [lat, setLat] = useState(13.12);
  const [zoom, setZoom] = useState(9);

  const getRoute = async (start, end) => {
    // make a directions request using cycling profile
    // an arbitrary start will always be the same
    // only the end or destination will change
    const query = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/cycling/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
      { method: "GET" }
    );
    const json = await query.json();
    const data = json.routes[0];
    const route = data.geometry.coordinates;
    const geojson = {
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: route,
      },
    };
    // if the route already exists on the map, we'll reset it using setData
    if (map.current.getSource("route")) {
      map.current.getSource("route").setData(geojson);
    }
    // otherwise, we'll make a new request
    else {
      map.current.addLayer({
        id: "route",
        type: "line",
        source: {
          type: "geojson",
          data: geojson,
        },
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#3887be",
          "line-width": 5,
          "line-opacity": 0.75,
        },
      });
    }

    // add turn instructions here at the end
  };

  useEffect(() => {
    if (!mapRoute || mapRoute.length == 0) return;
    if (mapRoute.length == 1) {
      const latLng = [mapRoute[0].lng, mapRoute[0].lat];
      new mapboxgl.Marker({ color: "blue" })
        .setLngLat(latLng)
        .addTo(map.current);
    } else if (mapRoute.length > 1) {
      const route = mapRoute.map((element) => {
        new mapboxgl.Marker({ color: "yellow" })
          .setLngLat([element.lng, element.lat])
          .addTo(map.current);
        return [element.lng, element.lat];
      });
      console.log(route, "route");
      // const latLng=[route[0][0],route[0][1]]
      // new mapboxgl.Marker({ color: "blue" }).setLngLat(latLng).addTo(map.current);
      const geojson = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: route,
        },
      };
      // if the route already exists on the map, we'll reset it using setData
      if (map.current.getSource("route")) {
        map.current.getSource("route").setData(geojson);
      }
      // otherwise, we'll make a new request
      else {
        map.current.addLayer({
          id: "route",
          type: "line",
          source: {
            type: "geojson",
            data: geojson,
          },
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "red",
            "line-width": 5,
            "line-opacity": 0.75,
          },
        });
      }
    }
  }, [mapRoute]);

  useEffect(() => {
    if (Object.keys(bookingObj).length == 0) return;
    const start = [bookingObj.pickUpLng, bookingObj.pickUpLat];
    const end = [bookingObj.destLng, bookingObj.destLat];

    new mapboxgl.Marker({ color: "green" }).setLngLat(start).addTo(map.current);

    new mapboxgl.Marker({ color: "red" }).setLngLat(end).addTo(map.current);

    map.current.setCenter(start);
    map.current.fitBounds(
      [
        start, // southwestern corner of the bounds
        end, // northeastern corner of the bounds
      ],
      {
        padding: { top: 60, bottom: 60, left: 60, right: 60 },
      }
    );

    // getRoute(start, end);
  }, [bookingObj]);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      zoom: zoom,
    });
  }, []);
  return <div ref={mapContainer} className="map-container" />;
};

export default MapBox;
